import { TextField, Typography } from "@mui/material";
import { Control, Controller, FieldPath, FieldValues } from "react-hook-form";

type SliderInputElementProps<T extends FieldValues> = {
    control: Control<T>;
    name: FieldPath<T>;
    disabled?: boolean;
    suffix?: string;
    min?: number;
    max?: number;
    step?: number | null;
};

export default function SliderTextInput<T extends FieldValues>({
    control,
    name,
    disabled,
    suffix,
    min,
    max,
    step,
}: SliderInputElementProps<T>) {
    return (
        <Controller
            control={control}
            name={name}
            rules={{
                min: min,
                max: max,
            }}
            render={({ field, fieldState: { error } }) => (
                <TextField
                    {...field}
                    value={field.value ?? ""}
                    onBlur={() => {
                        const numValue = Number(field.value);
                        if (field.value === "" || field.value === null) {
                            field.onChange(undefined);
                        } else if (!Number.isNaN(numValue)) {
                            field.onChange(numValue);
                        } else {
                            field.onChange(undefined);
                        }
                        field.onBlur();
                    }}
                    size="small"
                    variant="standard"
                    disabled={disabled}
                    error={!!error}
                    slotProps={{
                        htmlInput: {
                            step,
                            min,
                            max,
                            sx: {
                                textAlign: "right",
                                paddingRight: 1,
                                paddingBottom: 0.25,
                            },
                        },
                        input: {
                            sx: {
                                fontSize: "0.875rem",
                            },
                            endAdornment: suffix && (
                                <Typography variant="body2" color="text.secondary">
                                    {suffix}
                                </Typography>
                            ),
                        },
                    }}
                />
            )}
        />
    );
}
